(function () {
    'use strict';

    angular
        .module('portalApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        // public page (no login): IRS and cross-currency curves of all published countries
        $stateProvider.state('public-curves', {
            parent: 'app',
            url: '/curves',
            data: {
                authorities: [],
                pageTitle: 'publicCurves.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/public-curves/public-curves.html',
                    controller: 'PublicCurvesController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('publicCurves');
                    return $translate.refresh();
                }],
                publicCurves: ['$q', 'PublicCurves', function ($q, PublicCurves) {
                    return PublicCurves.get().$promise
                        .catch(function () {
                            return $q.when(null);
                        });
                }]
            }
        });
    }
})();
